import { render } from "./ProsesKonten.vue?vue&type=template&id=ee6b6bbc"
import script from "./ProsesKonten.vue?vue&type=script&lang=js"
export * from "./ProsesKonten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__